/**
 * Validação e formatação de CPF.
 */

export function validateCPF(cpfValue) {
  const numbers = String(cpfValue || '').replace(/\D/g, '')

  if (numbers.length !== 11) {
    return 'CPF deve conter 11 dígitos'
  }

  if (/^(\d)\1{10}$/.test(numbers)) {
    return 'CPF inválido'
  }

  let sum = 0
  for (let i = 0; i < 9; i++) {
    sum += parseInt(numbers.charAt(i), 10) * (10 - i)
  }
  let digit = 11 - (sum % 11)
  if (digit >= 10) digit = 0
  if (digit !== parseInt(numbers.charAt(9), 10)) {
    return 'CPF inválido'
  }

  sum = 0
  for (let i = 0; i < 10; i++) {
    sum += parseInt(numbers.charAt(i), 10) * (11 - i)
  }
  digit = 11 - (sum % 11)
  if (digit >= 10) digit = 0
  if (digit !== parseInt(numbers.charAt(10), 10)) {
    return 'CPF inválido'
  }

  return ''
}

export function formatCPF(value) {
  const numbers = String(value || '').replace(/\D/g, '')
  if (numbers.length <= 3) return numbers
  if (numbers.length <= 6) return `${numbers.slice(0, 3)}.${numbers.slice(3)}`
  if (numbers.length <= 9) return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6)}`
  return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6, 9)}-${numbers.slice(9, 11)}`
}

export function formatCpfCnpj(value) {
  const numbers = String(value || '').replace(/\D/g, '')
  if (numbers.length <= 11) return formatCPF(numbers)
  if (numbers.length <= 14) {
    return numbers
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2')
  }
  return numbers
}
